import React, { useContext } from 'react';
import { useParams } from 'react-router-dom';
import { CompanyContext } from '../../App';
import { BuilderEditorProvider } from './BuilderEditorContext';
import BuilderShell from '../../components/layout/BuilderShell';
import BuilderErrorBoundary from '../../components/builder/BuilderErrorBoundary';
import '../../design-system/index.scss';
import '../../components/ui/ui.scss';
import '../../components/layout/builder-shell.scss';

const BuilderPage = () => {
  const { id, langId } = useParams();
  const { userFullName } = useContext(CompanyContext);

  return (
    <BuilderErrorBoundary>
      <BuilderEditorProvider formId={id} langId={langId}>
        <BuilderShell userFullName={userFullName} />
      </BuilderEditorProvider>
    </BuilderErrorBoundary>
  );
};

export default BuilderPage;
